export const groupByKey = <T extends Record<string, any>, K extends keyof T>(
  arr: T[],
  key: K,
): Record<string, T[]> => {
  if (!arr) {
    return {};
  }
  return arr.reduce((acc, item) => {
    acc[item[key]] = [...(acc[item[key]] || []), item];
    return acc;
  }, {} as Record<string, T[]>);
};
